import React, { useCallback, useEffect, useState } from "react";
import { Handle, Position, useReactFlow } from "reactflow";
import { CloseIcon, UserNodeIcon } from "../iconSet/IconSet";
import { sourceCustomStyles, targetCustomStyles } from "../workflowCanvas/CustomStyles";
import { ProcessNodePropsTypes } from "./FlowchartTypes";

const ProcessNode: React.FC<ProcessNodePropsTypes> = ({ id, data }) => {

    const { deleteElements } = useReactFlow();
    const [isHovering, setIsHovering] = useState(false);

    const handleMouseOver = () => {
        setIsHovering(true);
    };
    const handleMouseOut = () => {
        setIsHovering(false);
    };

    const deleteNode = useCallback(() => {
        console.log(id);
        deleteElements({ nodes: [{ id }] });
    }, [id, deleteElements]);

    useEffect(() => {
        //console.log("DATA -> ", data)
    }, [data])
    return (
        <div className={`user-node`} onMouseEnter={handleMouseOver} onMouseLeave={handleMouseOut}>
            <UserNodeIcon width='1.5rem' />
            <span>{data.data.firstname} - (User)</span>
            {isHovering && (
                <div className={`node-close-ico`} onClick={deleteNode}>
                    <CloseIcon width='1rem' color="var(--color-main-red)"/>
                </div>
            )}
            
            <Handle id={"pro-target-top"} type="target" position={Position.Top} style={{...targetCustomStyles, background: "blue"}}/>
            <Handle id={"pro-source-right"} type="source" position={Position.Right} style={{...sourceCustomStyles, background: "yellow"}}/>
            <Handle id={"pro-target-left"} type="target" position={Position.Left} style={{...targetCustomStyles, background: "blue"}}/>
            <Handle id={"pro-source-bottom"} type="source" position={Position.Bottom} style={{...sourceCustomStyles, background: "yellow"}}/>
        </div>
    );
};

export default ProcessNode;
